import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;
/*=========枚举==============*/
/**
 * 礼品卡类型
 * @returns .
 */
export const giftCardTypeApi = () =>
  axios.get(`${base}/biz/gift-card/enums/type`);
/**
 *  礼品卡有效期
 * @returns .
 */
export const giftCardValidTypeApi = () =>
  axios.get(`${base}/biz/gift-card/enums/validType`);

/**
 *  礼品卡记录状态
 * @returns .
 */
export const giftCardRecordStatusApi = () =>
  axios.get(`${base}/biz/gift-card/enums/recordStatus`);
/*==============礼品卡制作====================*/
/**
 * 分页查询
 * @param {Object} params 参数参数
 * @returns .
 */
export function giftCardSpecPage(params) {
  return axios.get(`${base}/biz//gift-card-specifications/page`, {
    params: params
  });
}
/**
 * 保存
 * @param {Object} params
 * @returns .
 */
export function giftCardSpecSave(params) {
  return axios.post(`${base}/biz/gift-card-specifications/save`, params);
}
/**
 * 详情
 * @param {int} id
 * @returns .
 */
export function giftCardSpecInfo(id) {
  return axios.get(`${base}/biz/gift-card-specifications/`, {
    params: { id: id }
  });
}
/*=================礼品卡记录================*/
/**
 *  分页查询
 * @param {*} params
 * @returns
 */
export function giftCardRecordPage(params) {
  return axios.get(`${base}/biz/gift-card/record/page`, {
    params: params
  });
}
/**
 * 生成礼品卡
 * @param {Object} params
 * @returns
 */
export function giftCardRecordGenerate(params) {
  return axios.post(`${base}/biz/gift-card/record/generate`, params);
}
/**
 * 赠送
 * @param {Object} data
 * @returns
 */
export function giftCardGive(data) {
  return axios.post(`${base}/biz/gift-card/record/give`, data);
}
/**
 * 回收
 * @param {Object} data
 * @returns
 */
export function giftCardRecycle(data) {
  return axios.post(`${base}/biz/gift-card/record/recycle`, data);
}
/***订单***/
/**
 * 分页查询
 * @param {*} query
 * @returns
 */
export function loadOrderPage(query) {
  return axios.get(`${base}/biz/gift-card/order/page`, { params: query });
}
/**
 *  退款申请
 * @param {*} query
 * @returns
 */
export function loadRefundOrderPage(query) {
  return axios.get(`${base}/biz/gift/card/order/refund/page`, {
    params: query
  });
}
/**
 *  审核退款单
 * @param {*} data
 * @returns
 */
export function auditRefundOrder(data) {
  return axios.post(`${base}/biz/gift/card/order/refund/audit`, data);
}



// WEBPACK FOOTER //
// ./src/api/giftCard.js